import { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { CloseFilledIcon, SearchOutlinedIcon } from '@getgo/chameleon-icons/react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  searchField: (fullwidth) => ({
    display: 'flex',
    height: '2rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: tokens.surfaceColorSecondary,
    border: '1px solid transparent',
    padding: '0px 0.75rem',
    outline: 0,
    borderRadius: tokens.radiusSmall,

    '&:hover': {
      backgroundColor: tokens.surfaceColorSecondary,
      borderColor: tokens.borderColorDefault,
    },
    '&:focus-within': {
      backgroundColor: tokens.surfaceColorDefault,
      borderColor: tokens.focusBorderColorDefault,
      boxShadow: `0 0 0 1px ${tokens.focusColorHighlightDefault}`,
    },
    '& input': {
      backgroundColor: 'transparent',
      maxWidth: '100%',
      width: '100%',
      outline: 0,
      border: 'none',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: tokens.typeColorDefault,

      '&::placeholder': {
        color: tokens.typeColorSecondary,
      },
    },

    '& button': {
      '--goto-icon-color': tokens.surfaceColorDefault,
      ' --goto-icon-size': '10px',
      backgroundColor: tokens.iconColorSecondary,
      border: '1px solid transparent',
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      outline: 0,
      height: '1rem',
      width: fullwidth ? '0.45rem' : '1rem',
      '&:focus-visible': {
        borderColor: tokens.focusBorderColorDefault,
        boxShadow: tokens.elevationSmall,
      },
    },
  }),
}))

interface SearchFieldProps {
  onRemove?: React.MouseEventHandler<HTMLButtonElement> | undefined
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined
  value?: string
  placeholder?: string
  fullwidth?: boolean
  style?: React.CSSProperties
}

const SearchField: FC<SearchFieldProps> = ({ placeholder, onChange, onRemove, value, style, fullwidth = false }) => {
  const classes = useStyles(fullwidth)
  const t = useTranslate()

  return (
    <div style={style}>
      <div className={classes.searchField}>
        <span data-testid="search-icon">
          <SearchOutlinedIcon color={tokens.typeColorSecondary} size={'20px'} />
        </span>
        <label style={{ display: 'none', visibility: 'hidden' }} id="label" htmlFor="search-input-field">
          {t('Search')}
        </label>
        <input
          id="seach-input-field"
          placeholder={placeholder || t('Search')}
          type="text"
          aria-required="true"
          aria-disabled="false"
          onChange={onChange}
          value={value}
        />

        <span>
          <button
            data-testid="clear-button"
            style={{ display: value === '' ? 'none' : 'flex' }}
            aria-label={t('Clear Button')}
            onClick={onRemove}
          >
            <CloseFilledIcon />
          </button>
        </span>
      </div>
    </div>
  )
}
export default SearchField
